<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "border rounded mt-2 p-1" }, [
    _c(
      "div",
      { staticClass: "dispute-text mt-2" },
      [
        _vm._v(" " + _vm._s(_vm.$t("disputeStatus.Assistance-brief")) + " "),
        _c("b-link", [_vm._v(" 01:09:10")]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "mt-2" },
      [
        _c(
          "b-alert",
          { staticClass: "d-flex", attrs: { variant: "primary", show: "" } },
          [
            _c(
              "div",
              [
                _c("feather-icon", {
                  staticClass: "m-1",
                  attrs: { icon: "AlertCircleIcon", size: "16" },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "counterparty-alert-second" }, [
              _vm._v(" " + _vm._s(_vm.$t("disputeStatus.Alert")) + " "),
            ]),
          ]
        ),
      ],
      1
    ),
    _c("ol", { staticClass: "ol-text mt-1" }, [
      _c("li", [
        _vm._v(" " + _vm._s(_vm.$t("disputeStatus.staletementLi1")) + " "),
      ]),
      _c("li", [
        _vm._v(" " + _vm._s(_vm.$t("disputeStatus.staletementLi2")) + " "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/@core/components/dispute/DisputeResolved.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default ({
  render,
  staticRenderFns,
  components: {
    BButton: bootstrapvue["BButton"],
    BLink: bootstrapvue["BLink"]
  }
});

//# sourceURL=webpack:///./src/@core/components/dispute/DisputeResolved.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

